import { Component, OnInit } from "@angular/core";
import { NavService, Menu } from "../../services/nav.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {
  public menuItems: Menu[];
  public menuCategorias: any;

  constructor(private router: Router, public navServices: NavService) {
    this.navServices.listarCategorias().subscribe(
      (data) => {
        this.menuCategorias = data;
      },
      (err) => {}
    );

    this.navServices.items.subscribe(
      (menuItems) => (this.menuItems = menuItems)
    );

    this.router.events.subscribe((event) => {
      this.navServices.mainMenuToggle = false;
    });
  }

  abrirMenu(item: any) {}

  ngOnInit(): void {}

  mainMenuToggle(): void {
    this.navServices.mainMenuToggle = !this.navServices.mainMenuToggle;
  }

  // Click Toggle menu (Mobile)
  toggletNavActive(item) {
    item.active = !item.active;
  }

  redirecionarHome() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/home/fashion"]);
  }

  redirecionarSobre() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/pages/aboutus"]);
  }

  redirecionarCadastreSe() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/pages/register"]);
  }

  redirecionarSejaParceiro() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/pages/registrar-empresa"]);
  }

  redirecionarGuiaMonkey() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/pages/collection"]);
  }

  redirecionarFaleConosco() {
    localStorage.setItem("linkDireto", "false");
    this.router.navigate(["/pages/contact"]);
  }
}
